import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import FloatingElements from './FloatingElements';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

export default function CTASection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      const t = { trigger: ref.current, start: 'top 55%' };
      gsap.fromTo('.cta-bg-text', { opacity: 0, scale: 0.82 }, { opacity: 0.06, scale: 1, duration: 1.3, ease: 'power4.out', scrollTrigger: t });
      gsap.fromTo('.cta-main', { opacity: 0, y: 50, scale: 0.85 }, { opacity: 1, y: 0, scale: 1, duration: 1.1, delay: 0.2, ease: 'power4.out', scrollTrigger: t });
      gsap.fromTo('.cta-bar', { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 1, delay: 0.4, ease: 'power4.out', scrollTrigger: t });
      gsap.fromTo('.cta-btn', { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 1, delay: 0.55, ease: 'power4.out', scrollTrigger: t });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec cta" ref={ref}>
      <FloatingElements />
      <div className="cta-center">
        <span className="pill cta-pill">ANDA BELUM TERLAMBAT UNTUK BERJAYA</span>
        <div className="cta-stack">
          <span className="cta-bg-text">TRADE</span>
          <h1 className="cta-main">LIKE A PRO<span className="cta-dot">.</span></h1>
        </div>
        <div className="cta-bar">
          <span className="cta-item"><span className="gold-dot" />ADAM DANISH</span>
          <span className="cta-sep" />
          <span className="cta-item"><span className="gold-dot" />FREE SHIPPING</span>
          <span className="cta-sep" />
          <span className="cta-item"><span className="gold-dot" />100% MONEY BACK</span>
        </div>
        <div className="cta-btn">
          <button className="btn-white" onClick={() => document.querySelector('#order-form')?.scrollIntoView({ behavior: 'smooth' })}>
            DAPATKAN BUKU TLP
          </button>
        </div>
      </div>
    </section>
  );
}
